export type AnalyticsProvider = 'umami';

export type AnalyticsConfig = {
  provider: AnalyticsProvider;
  scriptUrl: string;
  websiteId: string;
};

export function getAnalyticsConfig(): AnalyticsConfig | null {
  const provider = process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER;
  if (provider !== 'umami') return null;

  const scriptUrl = process.env.NEXT_PUBLIC_UMAMI_SCRIPT_URL;
  const websiteId = process.env.NEXT_PUBLIC_UMAMI_WEBSITE_ID;

  if (!scriptUrl || !websiteId) return null;

  return { provider: 'umami', scriptUrl, websiteId };
}
